<template>
  <div>
    <Ibox v-if="ver.mostrar" :back="'true'" :titulo="'Ver formulario'">
      <FormGroup
          cols="4"
          label="Nombre formulario">
        <span class="form-control">{{formulario.nombre}}</span>
      </FormGroup>
      <FormGroup
          cols="8"
          label="Instrucciones de llenado">
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <span v-else class="form-control">{{formulario.instrucciones}}</span>
      </FormGroup>
      <FormGroup
          cols="3"
          label="Permitir guardar sin enviar">
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <span v-else class="form-control">{{formulario.guardar_sin_enviar ? 'Si' : 'No'}}</span>
      </FormGroup>
      <FormGroup
          cols="3"
          label="Confirmación de envio al realizar formulario">
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <span v-else class="form-control">{{formulario.confirmacion_envio ? 'Si' : 'No'}}</span>
      </FormGroup>
      <FormGroup
          cols="3"
          label="Inspector asigna ejecutor">
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <span v-else class="form-control">{{formulario.inspector_asigna_ejecutor ? 'Si' : 'No'}}</span>
      </FormGroup>
      <FormGroup
          cols="3"
          label="Formulario se verifica despues de terminado">
        <b-skeleton type="input" v-if="loading"></b-skeleton>
        <span v-else class="form-control">{{formulario.verificar_formulario ? 'Si' : 'No'}}</span>
      </FormGroup>
      <b-col cols="12">
        <DataTable
          :loading="loading"
          :columns="ver.columns"
          :rows="ver.rows"
          :searching="false"
          :paging=false
          :buttons=false
          clases="table-bordered table-hover table-condensed nowrap">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'objeto_tipo'">
              {{ utils.formularioDescTipo(props.row.objeto_tipo) }}
            </span>
            <span v-else-if="props.column.field == 'objeto_obligatorio'">
              {{ props.row.objeto_obligatorio == 'true' ? 'Si': 'No' }}
            </span>
            <span v-else-if="props.column.field == 'objeto_ejecutor'">
              {{ descEjecutor(props.row.objeto_ejecutor) }}
            </span>
            <span v-else-if="props.column.field == 'objeto_seleccion_nombre'">
              {{ descSeleccion(props.row) }}
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </DataTable>
      </b-col>
      <b-col style="margin-top:20px" v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando formulario'"/></b-button>
        <b-button v-else-if="editing" variant="primary"><Loading :size="'1'" :text="'Modificando formulario'"/></b-button>
        <span v-else>
          <b-button v-if="formulario.habilitado == 'S'" variant="danger" v-on:click="editarSinData('N', formulario.publicado)">Deshabilitar</b-button>
          <b-button v-else variant="success" v-on:click="editarSinData('S', formulario.publicado)">Habilitar</b-button>
          <b-button variant="primary" style="margin-left:5px" v-on:click="editarFormulario()">Editar formulario</b-button>
          <b-button v-if="formulario.publicado == 'N'" variant="success" style="margin-left:5px" v-on:click="editarSinData(formulario.habilitado, 'S')">Publicar</b-button>
        </span>
      </b-col>
    </Ibox>
    <Ibox v-else :back="'true'" :titulo="'Editar formulario'">
      <FormGroup
          cols="4"
          label="Nombre">
        <input type="text" class="form-control" v-model="formulario.nombre">
      </FormGroup>
      <FormGroup
          cols="8"
          label="Instrucciones de llenado">
        <input type="text" class="form-control" v-model="formulario.instrucciones">
      </FormGroup>
      <b-col cols="12">
        <b-row>
          <FormGroup
            cols="3"
            label="Permitir guardar sin enviar">
            <CheckBox v-model='formulario.guardar_sin_enviar' @update-value="setGuardarSinEnviar"></CheckBox>
          </FormGroup>
          <FormGroup
            cols="3"
            label="Confirmación de envio al realizar formulario">
            <CheckBox v-model='formulario.confirmacion_envio' @update-value="setConfirmacionEnvio"></CheckBox>
          </FormGroup>
          <FormGroup
            v-if="formulario.data.find((element) => element.objeto_ejecutor == '2')"
            cols="3"
            label="Inspector asigna ejecutor">
            <CheckBox v-model='formulario.inspector_asigna_ejecutor' @update-value="setInspectorAsignaEjecutor"></CheckBox>
          </FormGroup>
          <FormGroup
            v-if="formulario.data.find((element) => element.objeto_ejecutor == '2')"
            cols="3"
            label="Formulario se verifica despues de terminado">
            <CheckBox v-model='formulario.verificar_formulario' @update-value="setVerificarFormulario"></CheckBox>
          </FormGroup>
        </b-row>
      </b-col>
      <b-col cols="2" style="border-right: 1px solid">
        <h4 style="margin-bottom:15px">Click sobre un objeto para agregarlo al formulario</h4>
        <b-list-group flush>
          <div v-for="pregunta in ['1','2','3','4','5','10','12','6','7','8','9','11','13','14','15','16']" :key="pregunta.id">
            <b-button size="sm" v-on:click="agregarObjeto(pregunta)" style="margin-bottom:5px; text-align:left" variant="white">
              <b-icon :icon=utils.formularioIconTipo(pregunta) aria-hidden="true"></b-icon> {{ utils.formularioDescTipo(pregunta)}}
            </b-button>
          </div>
        </b-list-group>
      </b-col>
      <b-col cols="10">
        <b-row>
          <b-col cols="8">Pregunta</b-col>
          <b-col cols="1">Tipo</b-col>
          <b-col cols="1">Obligatorio</b-col>
          <b-col cols="1">Extras</b-col>
          <b-col cols="1"></b-col>
        </b-row>
        <draggable v-model="formulario.data" group="people" handle=".handle" @change="onChangeLista" @start="drag=true" @end="drag=false">
          <b-row style="margin-top:5px; margin-left:0px" v-for="objeto in formulario.data" :key="objeto.id">
            <b-col cols="8">
              <p class="h6 mb-2 handle" style="margin-top:7px;position: absolute;left: -8px;">
                <b-icon icon="arrow-down-up"></b-icon>
              </p>
              <input class="form-control" v-model="objeto.objeto_pregunta">
            </b-col>
            <b-col cols="1">
              <span>
                {{ utils.formularioDescTipo(objeto.objeto_tipo)}}
              </span>
            </b-col>
            <b-col cols="1">
              <b-button v-if="objeto.objeto_tipo != globales.objeto_tipo.cabecera  && objeto.objeto_tipo != globales.objeto_tipo.correlativo" size="sm" variant="outline-success" v-on:click="setObligatorio(objeto)">
                {{ descObligatorio(objeto )}}
              </b-button>
            </b-col>
            <b-col cols="1">
              <ExtraPregunta 
                @modal=modalExtrasObjeto
                :objeto=objeto>
              </ExtraPregunta>
            </b-col>
            <b-col cols="1">
              <b-button size="sm" variant="outline-danger" v-on:click="eliminarObjeto(objeto)">Eliminar</b-button>
            </b-col>
          </b-row>
        </draggable>
      </b-col>
      <b-col style="margin-top:20px" v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="editing" variant="primary"><Loading :size="'1'" :text="'Editando formulario'"/></b-button>
        <b-button v-else-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando formulario'"/></b-button>
        <span v-else>
          <b-button variant="primary" v-on:click="revisarReportePersonalizado(formulario.publicado)">Guardar</b-button>
          <b-button v-if="formulario.publicado == 'N'" style="margin-left:5px" variant="success" v-on:click="revisarReportePersonalizado('S')">Guardar y publicar</b-button>
        </span>
      </b-col>
    </Ibox>
    <b-modal :no-close-on-backdrop="true" size="xl" hide-footer ref="modal_objeto" :title="'Configurar pregunta'">
      <ModalPregunta 
        ref="modal_pregunta"
        :modal_objeto="modal_objeto" 
        @cerrarmodalpregunta="$refs['modal_objeto'].hide()"
        @guardarmodalpregunta="guardarModalPregunta"
        @modaleditarseleccion="modalEditarSeleccion"
        @modalagregarseleccion="modalAgregarSeleccion"
      ></ModalPregunta>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" size="xl" hide-footer ref="modal_editar_seleccion" :title="'Editar selección'">
      <EditarSeleccion 
        :id_seleccion="modal_editar_seleccion.id_seleccion" 
        @cerrarmodaleditarseleccion="cerrarModalEditarSeleccion">
      </EditarSeleccion>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" size="xl" hide-footer ref="modal_agregar_seleccion" :title="'Agregar selección'">
      <AgregarSeleccion 
        @cerrarmodalagregarseleccion="cerrarModalAgregarSeleccion">
      </AgregarSeleccion>
    </b-modal>
  </div>
</template>

<script>
import {formularioService, globales} from "@/services";
import {utils} from "@/helpers";

import ExtraPregunta from '../components/ExtraPregunta.vue';
import ModalPregunta from '../components/ModalPregunta.vue';
import EditarSeleccion from '../components/EditarSeleccion.vue';
import AgregarSeleccion from '../components/AgregarSeleccion.vue';

export default {
  components: { ExtraPregunta, ModalPregunta, EditarSeleccion, AgregarSeleccion },
  data() {
    return {
      globales,
      loading:true,
      editing:false,
      modal_objeto:{
        loading:true,
        objeto:{}
      },
      editar: {
        objeto_num:'1',
      },
      modal_editar_seleccion:{
        id_seleccion:null
      },
      ver:{
        mostrar:true,
        columns:[
          {label: 'Pregunta', field: 'objeto_pregunta'},
          {label: 'Tipo', field: 'objeto_tipo'},
          {label: 'Obligatorio', field: 'objeto_obligatorio'},
          {label: 'Fotos', field: 'objeto_fotos'},
          {label: 'Archivos', field: 'objeto_archivos'},
          {label: 'Ejecutor', field: 'objeto_ejecutor'},
          {label: 'Seleccion (Si aplica)', field: 'objeto_seleccion_nombre'}
        ],
        rows:[]
      },
      utils,
      formulario: utils.jd64(this.$route.params.formulario),
    }
  },
  mounted(){
    this.getFormulario();
    this.$store.commit("pagina/setTitulo",'Configuración / Formularios / Ver ' + this.formulario.nombre);
  },
  methods: {
    onChangeLista() {
      this.formulario.data.forEach((element, index) => {
        element.objeto_num = (index+1).toString();
      });
    },
    editarFormulario(){
      this.ver.mostrar = false;
      this.$store.commit("pagina/setTitulo",'Configuración / Formularios / Editar ' + this.formulario.nombre);
    },
    revisarFormulario(){
      if(this.formulario.data.length == 0){
        utils.alerta({status:'warning',msg:'El formulario debe tener al menos un objeto'});

        return false;
      }

      if(this.formulario.data.find((element) => element.objeto_pregunta == '')){
        utils.alerta({status:'warning',msg:'Todos los objetos deben tener el texto "Pregunta"'});
        return false;
      }

      if(this.formulario.data.find((element) => [globales.objeto_tipo.seleccion_simple, globales.objeto_tipo.seleccion_multiple, globales.objeto_tipo.lista_correo].includes(element.objeto_tipo) && element.objeto_seleccion_id == '')){
        utils.alerta({status:'warning',msg:'Todas la preguntas con selección deben ser configuradas con una selección'});
        return false;
      }

      if(this.formulario.nombre == '' || this.formulario.instrucciones == ''){
        utils.alerta({status:'warning',msg:'Faltan campos obligatorios'});

        return false;
      }

      return true;
    },
    revisarReportePersonalizado(publicar){
      this.editing = true;

      formularioService.getFormularioReportes({
        habilitado:'S',
        id_formulario:this.formulario.id_formulario
      }).then(respuesta => {
        if(respuesta.status == 'success'){
          this.$fire({
            title:'Reporte personalizado',
            showCancelButton: true,
            html:'Esta editando un formulario que pertenece a uno o mas reportes personalizados, al editar este formulario todos los reportes personalizados asociados quedaran deshabilitados permamentemente, Esta seguro que desea continuar?',
            confirmButtonText:
              'Si',
            cancelButtonText:
              'No',
          }).then((confirm) => {
            if(confirm.value != null){ 
              this.revisarPublicado(publicar);
            }
          });
        }else{
          this.revisarPublicado(publicar);
        }
        this.editing = false;
      });
    },
    revisarPublicado(publicar){
      if(this.formulario.publicado == 'S'){
        this.$fire({
          title:'Formulario publicado',
          showCancelButton: true,
          html:'Esta editando un formulario ya publicado, las preguntas que fueron eliminadas o que se les modifico el campo "Pregunta" perderan la trazabilidad en los reportes de este formulario desde este momento hacia el pasado, Esta seguro que desea continuar?',
          confirmButtonText:
            'Si',
          cancelButtonText:
            'No',
        }).then((confirm) => {
          if(confirm.value != null){ 
            this.editarConData(publicar);
          }
        });
      }else{
        this.editarConData(publicar);
      }
    },
    editarConData(publicar) {
      if(this.revisarFormulario() == false){
        return;
      }

      this.editing = true;

      //limpio " y '
      this.formulario.data.forEach((element => {
        element.objeto_pregunta = element.objeto_pregunta.replace(/["']/g, "");
      }));

      formularioService.putFormulario({
        id_formulario: this.formulario.id_formulario,
        habilitado: this.formulario.habilitado,
        publicado: publicar,
        nombre: this.formulario.nombre,
        instrucciones: this.formulario.instrucciones,
        guardar_sin_enviar: this.formulario.guardar_sin_enviar,
        confirmacion_envio: this.formulario.confirmacion_envio,
        verificar_formulario: this.formulario.verificar_formulario,
        inspector_asigna_ejecutor: this.formulario.inspector_asigna_ejecutor,
        data:JSON.stringify(this.formulario.data)
      }).then(respuesta => {
        utils.alerta(respuesta);
        this.editing = false;
        if (respuesta.status == "success") {
          //socket
          this.$socket.emit('prevn', 
            {
              id_cliente:this.$store.state.usuario.id_cliente,
              dispatch:'usuario/sincronizar'
            }
          );

          this.$router.go(-1);
        }
      });
    },
    editarSinData(habilitado, publicado){
      this.editing = true;

      formularioService.putFormulario({
        id_formulario: this.formulario.id_formulario,
        habilitado: habilitado,
        publicado: publicado,
        nombre: this.formulario.nombre,
        instrucciones: this.formulario.instrucciones,
        guardar_sin_enviar: this.formulario.guardar_sin_enviar,
        confirmacion_envio: this.formulario.confirmacion_envio,
        verificar_formulario: this.formulario.verificar_formulario,
        inspector_asigna_ejecutor: this.formulario.inspector_asigna_ejecutor,
      }).then(respuesta => {
        utils.alerta(respuesta);
        //socket
        this.$socket.emit('prevn', 
          {
            id_cliente:this.$store.state.usuario.id_cliente,
            dispatch:'usuario/sincronizar'
          }
        );
        this.getFormulario();
        this.editing = false;
      });
    },
    getFormulario(){
      this.loading = true;

      formularioService.getFormulario(this.formulario).then(respuesta => {
        this.formulario = respuesta.data;
        this.formulario.confirmacion_envio = respuesta.data.confirmacion_envio == 'S' ? true : false;
        this.formulario.guardar_sin_enviar = respuesta.data.guardar_sin_enviar == 'S' ? true : false;
        this.formulario.verificar_formulario = respuesta.data.verificar_formulario == 'S' ? true : false;
        this.formulario.inspector_asigna_ejecutor = respuesta.data.inspector_asigna_ejecutor == 'S' ? true : false;
        this.formulario.data = JSON.parse(respuesta.data.data);

        this.ver.rows = respuesta.data.data;
        this.loading = false;
      });
    },
    modalEditarSeleccion(id_seleccion){
      this.modal_editar_seleccion.id_seleccion = id_seleccion;
      this.$refs['modal_editar_seleccion'].show();
    },
    modalAgregarSeleccion(){
      this.$refs['modal_agregar_seleccion'].show();
    },
    guardarModalPregunta(objeto){
      Object.assign(this.modal_objeto.objeto, objeto);
      this.$refs['modal_objeto'].hide();
    },
    modalExtrasObjeto(objeto){
      this.modal_objeto.loading = true;
      this.modal_objeto.objeto = objeto;
      this.$refs['modal_objeto'].show();
    },
    cerrarModalEditarSeleccion(){
      this.$refs['modal_editar_seleccion'].hide();
      this.$refs['modal_pregunta'].getOpciones();
    },
    cerrarModalAgregarSeleccion(){
      this.$refs['modal_agregar_seleccion'].hide();
      this.$refs['modal_pregunta'].getOpciones();
    },
    setGuardarSinEnviar(value){
      this.formulario.guardar_sin_enviar = value;
    },
    setConfirmacionEnvio(value){
      this.formulario.confirmacion_envio = value;
    },
    setVerificarFormulario(value){
      this.formulario.verificar_formulario = value;
    },
    setInspectorAsignaEjecutor(value){
      this.formulario.inspector_asigna_ejecutor = value;
    },
    setObligatorio(objeto){
      if(objeto.objeto_obligatorio == 'true'){
        objeto.objeto_obligatorio = 'false';
      }else if(objeto.objeto_obligatorio == 'false'){
        objeto.objeto_obligatorio = 'true';
      }else if(objeto.objeto_obligatorio){
        objeto.objeto_obligatorio = 'false';
      }else if(!objeto.objeto_obligatorio){
        objeto.objeto_obligatorio = 'true';
      }
    },
    eliminarObjeto(objeto){
      this.formulario.data = this.formulario.data.filter((element) => element != objeto);
    },
    agregarObjeto(id_tipo){
      if(this.formulario.data.length > 0){
        this.editar.objeto_num = (parseInt(this.formulario.data[this.formulario.data.length-1].objeto_num) + 1).toString();
      }

      let objeto = {
        objeto_qr:'0',
        objeto_tipo:id_tipo,
        objeto_pregunta:'',
        objeto_obligatorio:'false',
        objeto_fotos:'0',
        objeto_archivos:'0',
        objeto_seleccion_id:'',
        objeto_seleccion_nombre:'',
        objeto_seleccion_opciones:{opciones:[]},
        objeto_seleccion_lista_correo:[],
        objeto_ejecutor:'0',
        objeto_num:this.editar.objeto_num,
      };

      this.formulario.data.push(objeto);
    },
    descObligatorio(objeto){
      if(objeto.objeto_obligatorio == 'true'){
        return 'Si';
      }else if(objeto.objeto_obligatorio == 'false'){
        return 'No';
      }else if(objeto.objeto_obligatorio){
        return 'Si';
      }else{
        return 'No';
      }
    },
    descEjecutor(valor){
      if(valor == '0'){
        return '';
      }else if(valor == '2'){
        return 'Ejecutor responde pregunta';
      }else if(valor == '4'){
        return 'Pregunta puede generar una tarea que asigna el inspector';
      }else if(valor == '5'){
        return 'Pregunta puede generar una tarea que asigna el administrador de la categoria';
      }else{
        return valor;
      }
    },
    descSeleccion(objeto){
      let seleccion = this.$store.state.usuario.selecciones.find((element) => element.id_seleccion == objeto.objeto_seleccion_id);
      if(typeof(seleccion) === 'undefined'){
        return null;
      }else{
        return seleccion.desc_seleccion;
      }
    },
  }
}
</script>

<style scoped>
</style>
